import React, { FC } from 'react';
import { useQueryClient } from 'react-query';

import { logout } from 'modules/Session';
import { ErrorFallback } from 'modules/UI';

import { GET_DEVELOPER } from '../../providers';

type PropTypes = {
  error: unknown;
};

export const DeveloperErrorPlaceholder: FC<PropTypes> = () => {
  const queryClient = useQueryClient();

  return (
    <ErrorFallback
      actionLabelIntlKey="developer.error.content.reload"
      secondaryActionIntlKey="developer.error.content.exit"
      descriptionIntlKey="developer.error.content.body"
      onActionClick={(): void => {
        queryClient.refetchQueries(GET_DEVELOPER);
      }}
      onSecondaryActionClick={(): void => {
        logout();
      }}
    />
  );
};
